import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const AVATAR_SIZE = spacing.xl;
const EDIT_ICON_SIZE = spacing.m;

export const styles = createThemedStyles(theme => ({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flexShrink: 1,
  },
  editAvatarIcon: {
    position: 'absolute',
    top: -spacing.xxs,
    right: -spacing.xs,
    width: EDIT_ICON_SIZE,
    height: EDIT_ICON_SIZE,
    borderRadius: EDIT_ICON_SIZE / 2,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    borderWidth: 1,
    borderColor: theme.colors.borderColor,
    zIndex: 1,
  },
}));
